module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "table-data",
    on: {
      "mousedown": _vm.startDrag,
      "touchstart": _vm.startDrag
    }
  }, _vm._l((_vm.items), function(data, index) {
    return _c('li', {
      key: index,
      class: [
        'table-data-item',
        {
          'table-data-item--dragging': _vm.dragItemIndex === index
        } ],
      style: ({
        'transform': ("translate3d(" + (_vm.removable && _vm.dragItemIndex === index ? -_vm.dragValue.x : 0) + "px, 0, 0)")
      })
    }, [_vm._t("item", [_vm._v("\n      " + _vm._s(data.label || data.name) + "\n    ")], {
      itemdata: data,
      itemindex: index
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68da2de9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/table/TableData.vue
// module id = 112
// module chunks = 2